import { walkTranslatableUnits } from './walk';
import {
  H5PParams,
  H5PSemantics,
  TranslatableField,
  WalkerOptions,
} from './types';

/**
 * Ordered flat list of a content's translatable units. `params` is never
 * mutated; embeds `resolveSemantics` cannot resolve are skipped gracefully.
 */
export const extractTranslatableFields = (
  semantics: H5PSemantics,
  params: H5PParams,
  options?: WalkerOptions,
): TranslatableField[] =>
  walkTranslatableUnits(semantics, params, options).fields;
